export const mouseHoverLayer = (payload) => ({
  type: mouseHoverLayer.toString(),
  payload
})
mouseHoverLayer.toString = () => 'map/mouseHoverLayer'

export const setZoom = (payload) => ({
  type: setZoom.toString(),
  payload
})
setZoom.toString = () => 'map/setZoom'

const mapReducer = {
  [setZoom]: (draftState, { currentZoom }) => {
    draftState.map.zoom = currentZoom
  },
  [mouseHoverLayer]: (draftState, { lngLat }) => {
    draftState.mousePositionLayer = lngLat
  }
}

export default mapReducer
